import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { RootState } from "../../../../redux/rootReducers";
import {
  CircularAvatar,
  CommonHeader,
  DropDown,
  EmptyListPage,
  ErrorSuccessModal,
  Loader,
} from "../../../../components/commons";
import ReportsDateSelect from "../../../../components/commons/ReportsDateSelect/ReportsDateSelect";
import {
  formatDate,
  getCurrentMonthDates,
  handleDate,
  reverseDateFormat,
} from "../../../../utils/commonFunctions";
import Select from "react-select";
import {  getSingleUserAttendanceReportAction, resetTimeSheetError, resetTimeSheetMessage, resetTimeSheetStatusCode, resetTimeSheetSuccess , resetSingleAttendaceReportList, getSingleAttendanceDetailAction, resetSingleAttendanceDetail} from "../../../../redux/timeSheet";
import { getAllFinacClientUsersAction, getAttendanceDataAction, resetSession } from "../../../../redux/auth";
import {  GetSingleUserAttendanceReportDataPayloadType } from "../../../../commonTypes/timeSheetTypes";
import { GetAllFinacUserPayloadType, GetAttendanceTimePayloadType } from "../../../../commonTypes/authTypes";
import UserAttendanceReportCalenderView from "../../../../components/TimeSheetReports/Attendance/UserAttendanceReportCalenderView";
import SingleAttendanceModal from "../../../../components/TimeSheetReports/Attendance/SingleAttendanceModal";
import moment from "moment";
import { AttendanceReportListType } from "../../../../redux/timeSheet/timeSheetType";
import useDebounce from "../../../../customHooks/useDebounce";
import { components } from "react-select";
import { EmptyTimeSheetReportList } from "../../../../assets/images";

type AppProps = {
  token: string | null;
  fetching: boolean;
  message: string | null;
  error: string | null;
  statusCode: number | null;
  success: number | null;
  attendanceReportList:any;
  totalCount:number,
  totalUserCount: number | string | any;
  finacUsersList:any;
  userFetching:boolean;
  singleAttendanceDetail:any;
  dispatchResetSession: () => void;
  dispatchResetTimeSheetError: () => void;
  dispatchResetTimeSheetSuccess: () => void;
  dispatchResetTimeSheetMessage: () => void;
  dispatchResetTimeSheetStatusCode: () => void;
  dispatchResetSingleAttendanceReportList: () => void;
  dispatchGetSingleAttendanceReportList:(data:GetSingleUserAttendanceReportDataPayloadType)=>void;
  dispatchGetAllFinacUsersAction: (data:GetAllFinacUserPayloadType)=>void;
  dispatchGetSingleAttendanceDetailAction:(data:GetAttendanceTimePayloadType)=>void;
  dispatchResetAttendenceSingleDetailData: () => void;
};

export type DropDownItemType = {
  value: number | undefined;
  label: string | undefined;
};
export type ClientListType = {
  value: number |null;
  label: string | null;
};
type getAllClientPayload = {
  token: string;
  offset: number;
  limit: number;
  searchValue: string | undefined;
};
const AttendanceReport = ({
    token,
    error,
    statusCode,
    success,
    message,
    fetching,
    totalCount,
    attendanceReportList,
    finacUsersList,
    totalUserCount,
    userFetching,
    singleAttendanceDetail,
    dispatchResetSession, 
    dispatchResetTimeSheetSuccess,
    dispatchResetTimeSheetError,
    dispatchResetTimeSheetMessage,
    dispatchResetTimeSheetStatusCode,
    dispatchGetSingleAttendanceReportList,
    dispatchResetSingleAttendanceReportList,
    dispatchGetAllFinacUsersAction,
    dispatchGetSingleAttendanceDetailAction,
    dispatchResetAttendenceSingleDetailData
}: AppProps) => {
  const { start, end } = getCurrentMonthDates();
  const [offset, setOffset] = useState<number>(0);
  const [limit, setLimit] = useState<number>(20);
  const [showData, setShowData] = useState(false);
  const [userSelected, setUserSelected] = useState<any>({
    value: null,
    label: "Select User",
  });
  const [finalUserList, setFinalUserList] = useState<
    DropDownItemType[] | []
  >([]);
  const [displayStartDate, setDisplayStartDate] = useState("");
  const [displayEndDate, setDisplayEndDate] = useState("");
  const [startDate, setStartDate] = useState(start);
  const [endDate, setEndDate] = useState(end);
  const [toggle, setToggle] = useState<boolean>(false);
  const [text, setText] = useState<string>("");
  const [loadCondition, setLoadCondition] = useState(true);
  const [isModalVisible,setIsModalVisible]=useState(false);
  const [date,setDate]=useState("")
  const [location,setLocation]=useState("")

  useEffect(() => {
    dispatchResetTimeSheetSuccess()
    dispatchResetTimeSheetError()
    dispatchResetTimeSheetMessage()
    dispatchResetTimeSheetStatusCode()
  }, []);


  useEffect(() => {
    if (token) {
      let finalData = {
        token,
        search_term: text,
        user_type: "stco_users",
        limit,
        offset,
        status: "1" ,
      };

      if (+finacUsersList?.total_count) {
        if (+finacUsersList?.total_count > offset) {
          dispatchGetAllFinacUsersAction(finalData);
        }
      } else {
        dispatchGetAllFinacUsersAction(finalData);
      }
    }
  }, [offset]);

  const fetchNewData = (search: string) => {
    const finalData = {
      token,
      offset,
      limit,
      user_type: "stco_users",
      status: 1,
      search_term: text,
    };
    dispatchGetAllFinacUsersAction(finalData);
  };

  useDebounce(
    () => {
      if (text) {
        fetchNewData(text);
      } else {
        const finalData = {
          token,
          offset,
          limit,
          user_type: "stco_users",
          status: 1,
          search_term: "",
        };
        dispatchGetAllFinacUsersAction(finalData);
      }
    },
    500,
    [text]
  );


  useEffect(() => {
    if (finacUsersList?.data?.length > 0) {
      if (offset <= +finacUsersList?.total_count) {
        let finalUserData = finacUsersList?.data?.map((user: any) => {
          return {
            value: user.user_id,
            label: `${user.first_name} ${user.last_name}`,
            image: user?.profile_pic?.file_url
          };  
        });
        if (offset > 0) {
          setFinalUserList([...finalUserList, ...finalUserData]);
        } else {
          setFinalUserList([...finalUserData]);
        }
      }
    }
  }, [finacUsersList?.data]);

  const Option = (props: any) => {
    const { data } = props;
    return (
      <components.Option {...props}>
        <div
          className="d-flex justify-content-sm-start"
          style={{ gap: "10px" }}
        >
          <CircularAvatar
            name={data?.label}
            image={data?.image && data?.image}
          />
          {data?.label}
        </div>
      </components.Option>
    );
  };


  const checkBottom = (e: any) => {
    setLoadCondition(false);
    setOffset((prv) => prv + limit);
  };
  const onMenuClose = () => setLoadCondition(true);

  const handleStartDateChange = (date: string) => {
    const value = handleDate(date);
    setStartDate(value);
  };
  const handleEndDateChange = (date: string) => {
    const value = handleDate(date);
    setEndDate(value);
  };
  const handleChangeClient = (client: any) => {
    setUserSelected(client);
  };


  const handleSubmit = (id:string | null) => {
    setShowData(true);
     dispatchResetSingleAttendanceReportList();
    if (token) {
      let finalData = {
        token,
        start_date: startDate ? reverseDateFormat(startDate) : "",
        end_date: endDate ? reverseDateFormat(endDate) : "",
        user_id:id
      };
      dispatchGetSingleAttendanceReportList(finalData);
      setDisplayStartDate(handleDate(startDate));
      setDisplayEndDate(handleDate(endDate));
    }
  };

  const toggleModal=(info?:any)=>{
    dispatchResetAttendenceSingleDetailData()
      if(!isModalVisible){
        let finalDate=moment(info?.event?._def?.extendedProps?.date)?.format("DD-MM-YYYY")
        setDate(finalDate)
        setLocation(info?.event?._def?.extendedProps?.location)
        const finalData = {
          token,
          date: moment(info?.event?._def?.extendedProps?.date)?.format("DD-MM-YYYY"),
          user_id:info?.event?._def?.extendedProps?.userId
        };
        dispatchGetSingleAttendanceDetailAction(finalData);
      }
      setIsModalVisible((prev:boolean)=>!prev)
  }


  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => {
              dispatchResetSession();
              dispatchResetTimeSheetSuccess()
              dispatchResetTimeSheetError()
              dispatchResetTimeSheetMessage()
              dispatchResetTimeSheetStatusCode()
            }}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetTimeSheetSuccess()
              dispatchResetTimeSheetError()
              dispatchResetTimeSheetMessage()
              dispatchResetTimeSheetStatusCode()
            }}
          />
        );
      }
    }

    return false;
  };

  return (
    <>
      <div className="col-md-6">
        <CommonHeader title="User Attendance Report" />
      </div>
      <div className="col-md-12 mt-4">
        <div className="new-table-card">
          <div className="header pb-0">
            <div className="left-header">
              <div className="heading">
              User Attendance Report List
                {!showData ? (
                  <> </>
                ) : (
                  <>
                    {/* {!fetching && (
                      <div className="sub-heading mt-0">{`Total ${
                        totalCount ? totalCount : 0
                      } schedules found`}</div>
                    )} */}
                  </>
                )}
              </div>
            </div>
          </div>
          <div>
            <div className="d-flex align-items-start">
              <div className="col-md-2 pl-3 form-group d-flex flex-column p-0">
                <label className="mb-1">Select User <span className="color-red">*</span></label>
                <Select
                  options={finalUserList}
                  value={userSelected}
                  components={{ Option }}
                  cacheOptions
                  onChange={handleChangeClient}
                  onMenuScrollToBottom={(e: any) => checkBottom(e)}
                  onInputChange={(e: string) => {
                    setLoadCondition(false);
                    setText(e);
                    setOffset(0);
                  }}
                  onMenuClose={onMenuClose}
                  isLoading={!loadCondition && fetching}
                />
              </div>
              <div className="form-group ml-3">
                <label className="mb-1">Date <span className="color-red">*</span></label>
                <div>
                  <ReportsDateSelect
                    setToggle={setToggle}
                    toggle={toggle}
                    startDate={startDate ? startDate : ""}
                    endDate={endDate ? endDate : ""}
                    handleStartDateChange={handleStartDateChange}
                    handleEndDateChange={handleEndDateChange}
                    type={"schedulingReport"}
                    minDate={"2023-12-01"}
                  />
                </div>
              </div>
              <div className="ml-3" style={{ marginTop: "29px" }}>
                {/* <label className='mt-1'></label> */}
                <button
                  className="btn btn-primary pl-3 pb-2"
                    // disabled={!userSelected?.value}
                  disabled={
                    !userSelected?.value ||
                    !startDate?.length ||
                    !endDate?.length
                  }
                  onClick={()=>handleSubmit(userSelected?.value)}
                >
                  Apply
                </button>
              </div>
            </div>
          </div>
          {(!fetching && (!showData || attendanceReportList?.length===0))? (
           <div className="pb-4 pl-0 pr-0 pt-4">
           <EmptyListPage
             title="No Attendance List Found!"
             imageWidth="30%"
             image={EmptyTimeSheetReportList}
             showAddButton={false}
           />
           </div>
          ) : (
            <div>
               <UserAttendanceReportCalenderView
                data={attendanceReportList}
                fetching={fetching}
                totalCount={totalCount}
                startDate={startDate}
                endDate={endDate}
                displayStartDate={displayStartDate}
                displayEndDate={displayEndDate}
                setIsModalVisible={setIsModalVisible}
                toggleModal={toggleModal}
              />
            </div>
          )}

          {
            isModalVisible ? <SingleAttendanceModal
            toggleModal={toggleModal}
            isOpen={isModalVisible}
            attendenceData={singleAttendanceDetail?.response}
            totalAttendanceHours={singleAttendanceDetail?.total_time}
            fetching={fetching}
            date={date}
            location={location}
            /> :null
          }
        </div>
      </div>
      {handleErrorModal()}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
    token: state.auth.token,
    error: state.timeSheet.error,
    statusCode: state.timeSheet.statusCode,
    success: state.timeSheet.success,
    message: state.timeSheet.message,
    fetching: state.timeSheet.fetching,
    totalCount:state.timeSheet.reportListCount,
    attendanceReportList:state.timeSheet.attendanceReportList,
    finacUsersList: state.auth.finacClientUsersList,
    totalUserCount: state.auth.totalUserCount,
    userFetching: state.auth.fetching,
    singleAttendanceDetail:state.timeSheet.singleAttendanceDetail
});

const mapDispatchToProps = (dispatch: any) => ({
    dispatchResetSession: () => dispatch(resetSession()),
    dispatchResetTimeSheetSuccess: () => dispatch(resetTimeSheetSuccess()),
    dispatchResetTimeSheetError: () => dispatch(resetTimeSheetError()),
    dispatchResetTimeSheetMessage: () => dispatch(resetTimeSheetMessage()),
    dispatchResetTimeSheetStatusCode: () => dispatch(resetTimeSheetStatusCode()),
    dispatchResetSingleAttendanceReportList:()=> dispatch(resetSingleAttendaceReportList()),
    dispatchGetSingleAttendanceReportList:(data:GetSingleUserAttendanceReportDataPayloadType)=>dispatch(getSingleUserAttendanceReportAction(data)),
    dispatchGetAllFinacUsersAction: (data:GetAllFinacUserPayloadType) => dispatch(getAllFinacClientUsersAction(data)),
    dispatchGetSingleAttendanceDetailAction: (data: GetAttendanceTimePayloadType) =>
    dispatch(getSingleAttendanceDetailAction(data)),
    dispatchResetAttendenceSingleDetailData: () => dispatch(resetSingleAttendanceDetail()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AttendanceReport);
